module.exports = __webpack_public_path__ + "static/media/unispace.968f5408.png";